import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imUpperHeader', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/header/upper_header.html'),
        controller: 'UpperHeaderController',
        controllerAs: 'UpperHeaderCtrl',
        bindings: {
            userType: '<',
            isFullWidth: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/header/upper_header.component.ts